module.exports = __webpack_public_path__ + "img/header-diamondJewelry025Carat.d70f5cf.jpg";